import { api } from "@/api";
import { AddBettingMarketParams, BettingMarketDto } from "@/types/ApiResponses/BettingMarket";

export const addBettingMarket = async (params: AddBettingMarketParams): Promise<BettingMarketDto> => {
  const res = await api.client.post(`/betting-markets-new`, params);
  return res.data;
};
